<template>
    <div
      class="flex flex-wrap sm:flex-nowrap gap-2 sm:gap-0 px-1 sm:px-0"
    >
      <slot />
    </div>
  </template>